import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';


  export const insertFreightRequest = createAsyncThunk(
    'insertFreightRequest',
    async (data) => {
        let url = baseUrl+'insertPricing';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
       
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error"){
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const sent_Request = createAsyncThunk(
    'sent_Request',
    async (data) => {
        let url = baseUrl+'getSent_request';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
 
        if(response.status === "success"){
         
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const recieve_Request = createAsyncThunk(
    'recieve_Request',
    async (data) => {
      const token=Cookies.get("token");
      let url = baseUrl+'getFillterd_request';
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
        
         
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const Request_Approve = createAsyncThunk(
    'Request_Approve',
    async (data) => {
        let url = baseUrl+'request_accept';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
        
         
            return Promise.resolve(response)
        } else if(response.status === "error"){
            return Promise.resolve(response)
        }else {
          return Promise.reject(response)
      }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const ApprovedRequestGet = createAsyncThunk(
    'ApprovedRequestGet',
    async (data) => {
        let url = baseUrl+'ApprovedRequestGet';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
        
         
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const DeleteRequest = createAsyncThunk(
    'DeleteRequest',
    async (data) => {
        let url = baseUrl+'DeleteRequest';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
          return Promise.resolve(response)
        } else if(response.status === "error") {
          return Promise.resolve(response)
        }else {
          return Promise.reject(response)
      }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  